import { DocumentType } from '../generated/prisma/enums.js';
export const DOCUMENT_TYPE_CATEGORY_MAPPING = {
    [DocumentType.PAYROLL]: 'Personale > Stipendi',
    [DocumentType.TAX_PAYMENT]: 'Tassa > IVA',
    [DocumentType.INPS_CONTRIBUTION]: 'Personale > Contributi',
    [DocumentType.INAIL_PREMIUM]: 'Personale > Contributi',
    [DocumentType.PA_DEBT]: 'Tassa',
};
export function hasDocumentTypeCategoryMapping(type) {
    return type in DOCUMENT_TYPE_CATEGORY_MAPPING;
}
export function getCategoryPathForDocumentType(type) {
    return DOCUMENT_TYPE_CATEGORY_MAPPING[type];
}
//# sourceMappingURL=document-type-category-mapping.js.map